import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Button } from "@mui/material";
import { styles } from "./styles";

export const EnterpriseDetails = (): JSX.Element => {
  const openMailToLink = () => {
    const recipient = "hello@ommuse.com";
    const mailtoLink = `mailto:${recipient}`;
    const newTab = window.open(mailtoLink);
    if (newTab) {
      newTab.focus();
    } else {
      window.location.href = mailtoLink;
    }
  };
  return (
    <>
      <p style={{ marginTop: "3px" }}>
        Contact us to learn more about our Enterprise offerings.
      </p>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          onClick={openMailToLink}
          sx={{ ...styles.button, width: "100%", margin: 0 }}
        >
          Contact us
        </Button>
      </Box>
      <Box sx={{ textAlign: "left", marginTop: "20px" }}>
        <ul style={{ marginLeft: "0", paddingLeft: "0" }}>
          <li style={styles.planDetailsRow}>
            <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
            Private Storage
          </li>
          <li style={styles.planDetailsRow}>
            <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
            Private Cloud Deployment
          </li>
          <li style={styles.planDetailsRow}>
            <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
            WhiteLabeling
          </li>
        </ul>
      </Box>
    </>
  );
};
